




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PaymentSuccessfulModalComponent extends Vue {
  public $refs!: {
    modal: any;
  };

  @Prop(String) public readonly email!: string;
  @Prop(String) public readonly id!: string;
  @Prop(Boolean) public readonly isPreview!: boolean;

  private reset() {
    this.$emit('reset');
  }

  private close() {
    this.reset();
    this.$refs.modal.hide();
  }
}
